import { List } from 'immutable';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';
import * as FolderApi from 'documents-ui/api/FolderApi';
import allSettled from 'hs-promise-utils/allSettled';
import getUserView from '../lib/getUserView';
import { isUngatedToCHIRPEndpoints } from '../utils/gates';
const createSearchResult = savedFolder => SearchResultRecord.initFromJS({
  name: savedFolder.get('name'),
  contentId: savedFolder.get('id') ? parseInt(savedFolder.get('id'), 10) : null,
  contentType: SearchContentTypes.DOCUMENTS_FOLDER,
  userId: savedFolder.get('userId'),
  createdAt: savedFolder.get('createdAt'),
  updatedAt: savedFolder.get('updatedAt'),
  userView: savedFolder.get('userView')
});
function createSearchResultCHIRP(savedFolder) {
  return SearchResultRecord.initFromJS({
    name: savedFolder.name,
    contentId: savedFolder.id,
    contentType: SearchContentTypes.DOCUMENTS_FOLDER,
    userId: savedFolder.userId,
    createdAt: savedFolder.createdAt,
    updatedAt: savedFolder.updatedAt,
    // Construct userView using getUserView helper
    userView: getUserView(savedFolder.userId)
  });
}
export const saveFolder = folder => () => {
  const isNew = !folder.contentId;
  const request = isNew ? FolderApi.createFolder : FolderApi.updateFolder;
  const isChirpEnabled = isUngatedToCHIRPEndpoints();
  request(folder).then(savedFolder => {
    const folderSearchResult = isChirpEnabled ? createSearchResultCHIRP(savedFolder) : createSearchResult(savedFolder);
    if (isNew) {
      return IndexUIActions.addResult(folderSearchResult);
    }
    return IndexUIActions.updateResult(folderSearchResult);
  }).catch(() => {
    const alertName = isNew ? 'saveFolder' : 'updatedFolder';
    addAlert(alertName, 'danger', {
      name: folder.name
    });
  });
};
export const deleteFolders = searchResults => () => {
  const folderSearchList = searchResults.toList();
  const removeFoldersPromises = searchResults.map(({
    contentId
  }) => FolderApi.removeFolder(contentId)).toArray();
  return allSettled(removeFoldersPromises).then(results => {
    const folderSearchIdsToRemove = results.reduce((idsToRemove, {
      status
    }, index) => {
      const {
        id,
        name
      } = folderSearchList.get(index);
      if (status === 'fulfilled' && id) {
        return idsToRemove.push(id);
      }
      addAlert('removeFolder', 'warning', {
        name
      });
      return idsToRemove;
    }, List());
    IndexUIActions.removeResults(folderSearchIdsToRemove);
  });
};